/*
 * @Author: 李明明
 * @Date: 2022-09-16 15:10:15
 * @LastEditTime: 2022-10-13 11:02:39
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/api/exam.js
 * 代码版权方：'政府采购信息网'
 */
import axios from "@/utils/axios";
let { post } = axios;
// 获取考试作弊信息
export const getExamPreventionCheatInfo = (data) => post("/exam/getExamPreventionCheatInfo", data);

// 增加学员切屏次数
export const addExamPaperSwitchScreenCount = (data) => post("/exam/addExamPaperSwitchScreenCount", data);

// 强制提交试卷接口
export const submitExamPaper = (data) => post("/exam/submitExamPaper", data);

/**
 * 考试说明
 * @param signUpUserId
 * @param examId
 * @param paperId 传paperId就返回倒计时，没传就不返回倒计时
 */
export const listExamExplain = (signUpUserId, examId, paperId) => {
  return post('/exam/listExamExplain', { signUpUserId, examId, paperId })
}

// 获取考试时间说明
export function queryExamTimeInfo(examId) {
  return post('/exam/queryExamTimeInfo', { examId })
}














